import React, { Component } from 'react';
import './index.css';

class Axinan extends Component {
  render() {
    return <div className="axinan-container">
      <div className="arrow arrow1" />
      <div className="arrow arrow2" />
      <div className="arrow arrow3" />
      <div className="arrow arrow4" />
      <div className="arrow arrow5" />
      <div className="arrow arrow6" />
      <div className="arrow arrow7" />
      <div className="arrow arrow8" />
    </div>
  }
}

export default Axinan;



// WEBPACK FOOTER //
// ./src/components/Axinan/index.js